import { render } from "./logs.vue?vue&type=template&id=a5289c22"
import script from "./logs.vue?vue&type=script&lang=js"
export * from "./logs.vue?vue&type=script&lang=js"

import "./logs.vue?vue&type=style&index=0&id=a5289c22&lang=css"

import exportComponent from "F:\\code\\ywym\\ydd-zht-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__